import { GatewayHttpError } from '@/infrastructure/http/gatewayFetch';

/**
 * Why a save failed, by the status the API answered. The screen turns the code into
 * text: the API's own sentence exists only in Portuguese and often names a field of
 * the payload, which says nothing to the person who clicked save.
 */
export type ConfigSaveErrorCode =
  'invalidData' | 'unauthorized' | 'forbidden' | 'notFound' | 'conflict' | 'serverError' | 'unreachable';

const CODE_BY_STATUS: Record<number, ConfigSaveErrorCode> = {
  400: 'invalidData',
  401: 'unauthorized',
  403: 'forbidden',
  404: 'notFound',
  409: 'conflict',
  422: 'invalidData',
};

/** No HTTP answer at all (offline, API down) reads as unreachable, never as invalid data. */
export function saveErrorCode(error: unknown): ConfigSaveErrorCode {
  if (!(error instanceof GatewayHttpError)) {
    return 'unreachable';
  }
  return CODE_BY_STATUS[error.status] ?? 'serverError';
}
